import TariffPlan from "../../../utils/services/project/metering/tariffPlanService";
import crudTemplate from "../../../templates/crudTemplate";
let crud = crudTemplate(TariffPlan);

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    return crud.getters.getList(state);
  },
  getItem() {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item;
  }
};

const actions = {
  ...crud.actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
